import script from "./SubMenusUserCenter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubMenusUserCenter.vue?vue&type=script&setup=true&lang=ts"

import "./SubMenusUserCenter.vue?vue&type=style&index=0&id=2023dd2d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2023dd2d"]])

export default __exports__